import styled from 'styled-components';
export const StyledPayoutList = styled.div`
  margin-bottom: 1.2rem;
`;
